module.exports = __webpack_public_path__ + "static/media/crowfall.98c167de.jpg";